import type { EarningDeal } from '@/api/gen'
import type { EarningsRow } from '@/pages/rewards/hooks/use-earnings-table-cols'
import { safeNumber } from '@/utils/helpers'

/**
 * Its own module because the columns hook needs the id too, and reading it off `earnings-table`
 * — which imports that very hook — made the two circular.
 */
export const SUMMARY_ROW_ID = 'total'

/**
 * Sums the month's deals into the totals row that closes the table. Fields it does not total are
 * blanked, never inherited from a deal — each blank is what stops a cell claiming the total
 * belongs to that one deal (its category dot, its GGR/NGR tint, its multiplier badge).
 */
export const summaryRow = (deals: EarningDeal[]): EarningsRow => {
  const totals = deals.reduce(
    (acc, deal) => ({
      ggr: acc.ggr + safeNumber(deal.ggr),
      ngr: acc.ngr + safeNumber(deal.ngr),
      edge_earned: acc.edge_earned + safeNumber(deal.edge_earned),
      edge_credited: acc.edge_credited + safeNumber(deal.edge_credited),
      currency: deal.currency,
    }),
    { ggr: 0, ngr: 0, edge_earned: 0, edge_credited: 0, currency: '' },
  )

  return {
    id: SUMMARY_ROW_ID,
    poker_room_name: 'Total',
    username: '',
    last_processed_category: '',
    edge_calculation_base: '',
    ggr: totals.ggr.toString(),
    ngr: totals.ngr.toString(),
    edge_earned: totals.edge_earned.toString(),
    edge_credited: totals.edge_credited.toString(),
    currency: totals.currency,
  }
}
